import { translate } from '../../../common/intl';
import { ColumnDefinition } from '../../components/KendoDataGrid/KendoDataGrid.types';
import GroupsCellTemplate from './components/GroupCellTemplate';
import RadioCellTemplate from './components/RadioCellTemplate';
import TextCellTemplate from './components/TextCellTemplate';

export default function createSchema (
): Array<ColumnDefinition<{}>> {
  return [
    {
      id: 'lotNumber',
      field: 'lotNumber',
      title: translate('form.builder.deviation.affected.lot.number'),
      template: TextCellTemplate,
      width: 300,
    },
    {
      id: 'whereUsed',
      field: 'whereUsed',
      title: 'form.builder.deviation.affected.where.used',
      template: RadioCellTemplate,
      width: 100,
    },
    {
      id: 'serialNumbers',
      field: 'serialNumbers',
      title: 'form.builder.deviation.affected.serial.numbers',
      editable: true,
      template: GroupsCellTemplate,
    },
  ];
}
